/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Award = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "8", r: "6" }],
    ["path", { d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" }]
  ]
];

export { Award as default };
//# sourceMappingURL=award.js.map
